// extracted by mini-css-extract-plugin
export default {"tableTabs":"stylesTableTabs_tableTabs__UlG5G","tableTab":"stylesTableTabs_tableTab__TPAPj","active":"stylesTableTabs_active__vEVr1"};